export default __webpack_public_path__ + "static/media/personal_data.46c90114.svg";